/**
 * System Module Routes
 * Routes for Module Management & System X-Ray
 * Story: Module Management & System X-Ray
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

// Lazy load components
const ModulesManagement = lazy(() => import("@/pages/admin/modules/ModulesManagement"));
const ModuleDetailsPage = lazy(() => import("@/pages/admin/modules/ModuleDetailsPage"));

export const systemRoutes: ModuleRoutes = {
  moduleId: "system",
  basePath: "/admin/modules",
  routes: [
    {
      path: "/admin/modules",
      element: <ModulesManagement />,
      permission: { resource: "modules", action: "read" },
    },
    {
      path: "/admin/modules/:moduleId",
      element: <ModuleDetailsPage />,
      permission: { resource: "modules", action: "read" },
    },
    // Aliases PT-BR (Fix MEGA #2, 2026-05-17): URLs em portugues redirecionam
    // pra rota canonica inglesa. Sidebar items podem usar qualquer convencao.
    {
      path: "/admin/modulos",
      element: <ModulesManagement />,
      permission: { resource: "modules", action: "read" },
    },
    {
      path: "/admin/modulos/:moduleId",
      element: <ModuleDetailsPage />,
      permission: { resource: "modules", action: "read" },
    },
  ],
};
